import { render, staticRenderFns } from "./Workspace.vue?vue&type=template&id=43a35f18&"
import script from "./Workspace.vue?vue&type=script&lang=ts&"
export * from "./Workspace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports